import React, { useState } from 'react';
import { animated, useSpring } from 'react-spring';
import { toast } from 'react-toastify';
import { createOrganization, removeFromURL } from '../../../functions';

// components:
import Backbutton from '../../global/Backbutton';
import CheckboxGroup from "../../global/CheckboxGroup";
import MultiSelectInput from "../../global/MultiSelectInput";

// assets:
import CheckMark from '../../../assets/checkmark.svg'

const AddOrganization = ({ db }) => {
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [city, setCity] = useState('');
  const [orgNr, setOrgNr] = useState('');

  const submit = (e) => {
    e.preventDefault();
    if (db == null) {
      toast.error(
        'Någonting gick fel. Vänligen ladda om sidan och försök igen.'
      );
      return;
    }
    if (name === '') {
      toast.error('Ange organisationens namn');
      return;
    }
    if (address === '') {
      toast.error('Ange organisationens address');
      return;
    }
    if (postalCode === '') {
      toast.error('Ange postnummer');
      return;
    }
    if (city === '') {
      toast.error('Ange ort');
      return;
    }
    if (orgNr === '') {
      toast.error('Ange organisationens organisationsnummer');
      return;
    }

    var notificationoptions = {
      newbooking: newBookingNotifs,
      statuschanged: statusChangeNotifs,
      completedNotifs: completedNotifs
    }

    createOrganization(
      db,
      name,
      address,
      postalCode,
      city,
      orgNr,
      formOptions,
      notificationoptions,
      (callback) => {
        if (callback) {
          removeFromURL('addorganization');
        }
      }
    );
  };

  const [formOptions, setFormOptions] = useState([]);

  const [newBookingNotifs, setNewBookingNotifs] = useState(
    newBookingRows.filter((e) => e.default === true).map((a) => a.value)
  );
  const [statusChangeNotifs, setStatusChangeNotifs] = useState(
    statusChangeRows.filter((e) => e.default === true).map((a) => a.value)
  );
  const [completedNotifs, setCompletedNotifs] = useState(
    completedRows.filter((e) => e.default === true).map((a) => a.value)
  );

  const springprops = useSpring({
    to: { opacity: 1, x: 0, maxWidth: '100%', maxHeight: '100%' },
    from: { opacity: 0, x: 16, maxWidth: '100%', maxHeight: '100%' },
    config: { friction: 20, tension: 400 },
  });

  return (
    <animated.div style={springprops}>
      <div className="createbooking board">
        <Backbutton
          target={'Hantera användare'}
          onClick={() => removeFromURL('addorganization')}
        />
        <h1 className="title">Lägg till organisation</h1>
        <p className="subtitle">Skapa en ny organisation i portalen</p>
        <form onSubmit={submit}>
          <label htmlFor="name">Namn</label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            id="name"
            placeholder="Namn"
          />
          <label htmlFor="address">Organisationens adress</label>
          <input
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            id="address"
            placeholder="Adress"
          />
          <label htmlFor="postalcode">Postnummer</label>
          <input
            value={postalCode}
            onChange={(e) => setPostalCode(e.target.value)}
            id="postalcode"
            placeholder="Postnummer"
          />
          <label htmlFor="city">Stad</label>
          <input
            value={city}
            onChange={(e) => setCity(e.target.value)}
            id="city"
            placeholder="Ort"
          />
          <label htmlFor="orgnr">Organisationsnummer (XXYYZZ-XXYY)</label>
          <input
            value={orgNr}
            onChange={(e) => setOrgNr(e.target.value)}
            id="orgnr"
            placeholder="Organisationsnummer"
          />
          <label>Alternativ för bokningsformulär</label>
          <CheckboxGroup
            rows={formOptionRows}
            state={formOptions}
            setState={setFormOptions}
          />
          <label>
            <strong>Vem får notifikation vid:</strong>
          </label>
          <label>Ny bokning</label>
          <MultiSelectInput
            rows={newBookingRows}
            state={newBookingNotifs}
            setState={setNewBookingNotifs}
          />
          <label>Statusändring</label>
          <MultiSelectInput
            rows={statusChangeRows}
            state={statusChangeNotifs}
            setState={setStatusChangeNotifs}
          />
          <label>Färdigställd</label>
          <MultiSelectInput
            rows={completedRows}
            state={completedNotifs}
            setState={setCompletedNotifs}
          />
          <div></div>
          <div></div>
          <button type="button" onClick={submit}>
            <img src={CheckMark} className="doinvert" alt="" />
            Skapa organisation
          </button>
        </form>
      </div>
    </animated.div>
  );
};

export default AddOrganization;

const formOptionRows = [
  {
    label: "Visa kalender",
    value: "SHOW_CALENDAR",
  },
  {
    label: "Visa redigeringstyp",
    value: "SHOW_EDITINGSTYLE",
  },
  {
    label: "Möjlighet att själv boka tillfälle",
    value: "SHOW_BOOKINGTIME",
  },
];

const newBookingRows = [
  {
    label: "Bokare",
    value: "BOOKER",
    default: true,
  },
  {
    label: "Administratörer",
    value: "ADMINS",
    default: false,
  },
  {
    label: "Assistenter",
    value: "ASSISTANTS",
    default: false,
  },
];

const statusChangeRows = [
  {
    label: "Bokare",
    value: "BOOKER",
    default: true,
  },
  {
    label: "Administratörer",
    value: "ADMINS",
    default: false,
  },
  {
    label: "Assistenter",
    value: "ASSISTANTS",
    default: false,
  },
];

const completedRows = [
  {
    label: "Bokare",
    value: "BOOKER",
    default: true,
  },
  {
    label: "Administratörer",
    value: "ADMINS",
    default: false,
  },
  {
    label: "Assistenter",
    value: "ASSISTANTS",
    default: true,
  },
];
